// extracted by mini-css-extract-plugin
export var inf = "style-module--inf--8f087";
export var name = "style-module--name--c055f";
export var photosRow = "style-module--photos-row--c089d";